import React, { useState } from 'react';

import * as api from '@test_prep/app/ai_tutor/api';
import { useAITutorContext } from '@test_prep/app/ai_tutor/context';
import { Interaction, InteractionPart, TutoringSession } from '@test_prep/app/ai_tutor/types';

import AvailableSkillButton from '../available_skill_button';

interface Props {
  interactionPart: InteractionPart;
  updateInteractionPart: (interactionPart: InteractionPart) => void;
}

const DomainOffer: React.FC<Props> = (props) => {
  const { currentContext, hideTutor, pushToStack } = useAITutorContext();
  const [isAccepting, setIsAccepting] = useState(false);
  const [hasAccepted, setHasAccepted] = useState(props.interactionPart.content.domain.accepted);

  const acceptDomain = () => {
    setIsAccepting(true);

    if (props.interactionPart.content.domain.name === 'Customer Support') {
      (window as any).Forethought('widget', 'open');
      hideTutor();
      setIsAccepting(false);
    } else {
      // Create the new, child tutoring session
      api.createAITutoringSession({
        currentContext: currentContext(),
        domain: props.interactionPart.content.domain.klass,
        initialSkill: props.interactionPart.content.skill?.klass
      }).then((newTutoringSession) => {
        // Update the original domain offer interaction
        const updatedInteractionPart = { ...props.interactionPart };
        updatedInteractionPart.content.accepted = true;
        updatedInteractionPart.content.tutoringSessionId = newTutoringSession.id;

        api.updateAITutoringSessionInteractionPart(updatedInteractionPart).then((interactionPart) => {
          props.updateInteractionPart(interactionPart)

          setIsAccepting(false);
          setHasAccepted(true);

          pushToStack(newTutoringSession);
        });
      }).catch((error) => {
        setIsAccepting(false);
      });
    }
  };

  const resumeDomain = () => {
    pushToStack({
      id: props.interactionPart.content.tutoringSessionId,
      domain: props.interactionPart.content.domain.klass,
      skill: props.interactionPart.content.skill?.klass,
    });
  };

  return (
    <div className="d-flex flex-column gap-s">
      {props.interactionPart.content.text}

      <div className="d-flex">
        <div>
          <AvailableSkillButton
            domain={props.interactionPart.content.domain}
            onClick={props.interactionPart.content.tutoringSessionId ? resumeDomain : acceptDomain}
            submitting={isAccepting}
          >
            {hasAccepted ? 'Resume' : props.interactionPart.content.cta}
          </AvailableSkillButton>
        </div>
      </div>
    </div>
  );
};

export default DomainOffer;
